import { Grid } from '@mui/material';
import { ODSTagStatic, ODSText } from '@telekom-ods/react-ui-kit';
import type { ODSTagStaticType } from '@telekom-ods/react-ui-kit';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export interface ValidationGroupItem {
  key: string;
  name: string;
  tagLabel: string;
  tagType: ODSTagStaticType;
}

const Row = ({ item }: { item: ValidationGroupItem }): React.JSX.Element => (
  <Grid
    container
    className='upgrade-vrow'
  >
    <span
      className='upgrade-vname'
      title={item.name}
    >
      {item.name}
    </span>
    <ODSTagStatic
      label={item.tagLabel}
      type={item.tagType}
    />
  </Grid>
);

const ValidationGroup = ({
  title,
  items,
}: {
  title: string;
  items: ValidationGroupItem[];
}): React.JSX.Element | null => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  if (items.length === 0) return null;

  const sorted = [...items].sort(
    (a, b) => Number(a.tagType === 'success') - Number(b.tagType === 'success')
  );
  const [first, ...rest] = sorted;
  const issues = items.filter(i => i.tagType !== 'success').length;

  return (
    <Grid
      container
      direction='column'
      className='upgrade-vgroup'
    >
      <Grid
        container
        alignItems='center'
        gap={0.75}
        className='upgrade-vgroup-head'
      >
        <ODSText
          as='span'
          className='upgrade-section-title'
        >
          {title}
        </ODSText>
        <ODSText
          as='span'
          className='upgrade-text-muted'
        >
          ({String(items.length)})
        </ODSText>
        <span className='upgrade-vgroup-spacer' />
        <ODSTagStatic
          label={
            issues > 0
              ? intl.formatMessage({ id: 'issuesCount' }, { count: issues })
              : intl.formatMessage({ id: 'allHealthy' })
          }
          type={issues > 0 ? 'warning' : 'success'}
        />
      </Grid>

      {first && <Row item={first} />}

      {rest.length > 0 && (
        <>
          <button
            type='button'
            className='upgrade-showmore'
            onClick={() => {
              setOpen(prev => !prev);
            }}
          >
            {open
              ? intl.formatMessage({ id: 'showLess' })
              : intl.formatMessage({ id: 'showMore' }, { count: rest.length })}
          </button>
          {open && (
            <Grid
              container
              direction='column'
              className='upgrade-vlist'
            >
              {rest.map(item => (
                <Row
                  key={item.key}
                  item={item}
                />
              ))}
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default ValidationGroup;
